
import { useState } from 'react';

interface IProps {
    text: string;
    disabled?: boolean;
    className?: string;
    alertMessage?: string;
    variant?: 'outlined' | 'text'
    onClick: () => void;
}

export const Button: React.FC<IProps> = ({ text, alertMessage, variant = 'outlined', className = '', onClick: _onClick, disabled }) => {
    const [alert, setAlert] = useState<string>('');

    const onClick = () => {
        _onClick();

        if (alertMessage) {
            setTimeout(() => { setAlert(alertMessage) }, 150)
            setTimeout(() => { setAlert('') }, 1000)
        }
    }
    return (
        <button
            className={`button ${variant === 'outlined' ? 'heavy-border-shadow' : ''} ${className}`}
            onClick={onClick}
            disabled={disabled}
        >
            <p className="font-pixel-text decoration-inherit text-wrap">
                {alert ? alert : text}
            </p>
        </button>
    )
}